import { ApiBaseService } from '@/services/ApiBase.service'
import {
  Company,
  CompanyPagedResult,
} from '@/classes/generated-models'

export class CompaniesService extends ApiBaseService<Company, CompanyPagedResult> {
  readonly apiController = 'companies'
}
